import { Location } from '@angular/common';
import { AfterViewChecked, ChangeDetectorRef, Component, OnInit, ViewChild } from '@angular/core';
import { Router } from "@angular/router";
import { document } from 'ngx-bootstrap/utils';
import { Subscription } from 'rxjs';
import { SessionResponse } from '../../api/models/SessionResponse';
import { ApiErrorCode, COOKIES_TO_GET, ENVIRONMENTS, RouteURLConstants, SEARCH_CRITERIA, SEARCH_VALUE_KEY, ServiceURLConstants, TRANSLATE_CRITERIA_PARAMETER, UPS_PICKUP_POINT } from '../../constants/upplm.constants';
import { CARDS_STATUS, PLACARD_STATUS, STATUS_BY_TILE, TILE_STATUS } from '../../constants/upplm.constants.qvdashboard';
import { QVListRequest } from '../../interface/upplm.qvList';
import { AssignedClientKey, cards, cardsData, Clientkey, QVCookie, qvSummariesRequest, qvSummariesResponse, valueStaticQvSummary } from '../../interface/upplm.qvSummaries';
import { TranslateDataPipe } from '../../pipes/translation.pipe';
import { UpplmApiService } from '../../services/upplm.api.services';
import { UpsCommonService } from '../../services/upplm.common.service';
import { ConfigurationService } from '../../services/upplm.configuration.service';
import { ProgressBarService } from '../../services/upplm.progressbar.service';
import { QVDashboardSearchService } from '../../services/upplm.qvDashboardSearch.service';
import { UpplmSessionService } from '../../services/upplm.session.service';
import { UpsFilterComponent } from '../commonComponent/ups-filter/ups-filter.component';
import { ViewPorts } from '../commonComponent/ups-ham-menu/viewports';
import { BrowserWindow } from '../commonComponent/ups-ham-menu/window';
import { WindowResize } from '../commonComponent/ups-resize-window/screen-size.';

@Component({
    selector: 'qvsummary',
    template: require('./qvsummary.component.html'),
    styles: ['a{cursor:pointer} .ups-breadcrumb{ display: none !important;} .boxCategory{box-shadow: 0px 0px 6px #C67D30; border-radius: 7px; outline: none;}'],
    providers: [BrowserWindow, ViewPorts],
})

export class qvsummaryComponent implements OnInit, AfterViewChecked {
    sessionData: SessionResponse;
    public showComponent: boolean = false;
    showHeaderSearchMessage: boolean = false;
    qvSummryRequest: qvSummariesRequest;
    changeDays: boolean = false;
    valueStatic: valueStaticQvSummary = new valueStaticQvSummary();
    public displayList: boolean = false;
    public displaySummary: boolean = false;
    @ViewChild('actionFilter', { static: false })
    public actionFilter: UpsFilterComponent;
    timeToStamp = new Date();
    daysFilterSelectedDropdown: string = 'allDays';
    checked: boolean = false;
    responseView: qvSummariesResponse = new qvSummariesResponse();
    responseModel: qvSummariesResponse;
    responseModelClone: qvSummariesResponse;
    statusColor: string[] = [CARDS_STATUS.CONFIRM_PLACARD_DISPLAY, CARDS_STATUS.DISPLAYED, CARDS_STATUS.READY_FOR_PICKUPS];
    CARDS_STATUS_BINDING = CARDS_STATUS;
    listCardsData: Array<cardsData> = [];
    public totalCardsFlex: number = 0;
    public totalPlacards: number = 0;
    firstTimeCall: boolean = true;
    checkBoxSelected: Array<Clientkey> = [];
    applyDisabled: boolean = false;
    ClientKeySelected: Array<AssignedClientKey> = [];
    labelDays: string = '';
    nickNameLabel: string = '';
    filter: any;
    public displaySummaryLink: boolean = false;
    comesFromListView: boolean = true;
    cardStatusSelected: string = '';
    totalPlacardsLegend: string = '';
    allSelected: boolean = false;
    totalCancelledPlacards: number = 0;
    refreshListTimestamp: Object;
    public bar: boolean = false;
    public middleSize: boolean = false;
    public windowResize: WindowResize = new WindowResize();
    public sizeValue: string = '';
    public isLoading: boolean = true;
    showPlacardDetail: boolean = false;
    placardId: string = '';
    searchCkick: boolean = false;
    InputKeyword: string = '';
    InputKeywordMaxValue: boolean = false;
    clickedSearchKeywordInput: boolean = false;
    searchCategoryDropDown: string;
    errorCategoryDropDownSelected: boolean;
    firstInputValidator: boolean = false;
    errorKeywordHeader: boolean = false;
    selectedDropdDownSearch: string = 'Select One';
    statusDropdDownSearch: string = 'Ready';
    optionsDropdown: any[] = [];
    qvListRequest: QVListRequest = new QVListRequest();
    showstatusDropDown: boolean = false;
    searchFlag: boolean = false;
    showOptionSearchCategory: string = '';
    showOptionSearchKeyword: string = '';
    tempCategory: string = 'Select One';
    tempKeyword: string = '';
    tempSelectionStatus: boolean = false;
    errorCategoryHeader: boolean = false;
    showClasesInput: boolean = false;
    subscription: Subscription;
    optionSearchKeywordToShow: string = '';
    optionSearchCategoryToShow: string = '';
    globalRegionCountry: string = 'NA';
    messageSearch: string = '';
    createNewPickup: string = '';

    optionsSearch: any[] = [
        { value: 'Select One', content: this._translateData.transform('upplm.common.selectone') },
        { value: 'Placard ID', content: this._translateData.transform('upplm.common.placardid') },
        { value: 'Status', content: this._translateData.transform('upplm.common.status') },
        { value: 'Company Name', content: this._translateData.transform('upplm.common.companyname') },
        { value: 'Address', content: this._translateData.transform('upplm.cac.address') },
        { value: 'Client Key Nickname', content: this._translateData.transform('upplm.summarydashboard.selectclientkeyname') }
    ];

    statusDropdown: any[] = [
        { value: 'Ready', content: this._translateData.transform('upplm.common.ready') },
        { value: 'Awaiting UPS Approval', content: this._translateData.transform('upplm.common.awaitingapproval') },
        { value: 'Created', content: this._translateData.transform('upplm.common.created') },
        { value: 'First Pickup Date Delayed', content: this._translateData.transform('upplm.common.firstpickupdatedelayed') },
        { value: 'Expired', content: this._translateData.transform('upplm.common.expired') },
        { value: 'Pickups Paused', content: this._translateData.transform('upplm.common.pickupspaused') }
    ];

    constructor(private router: Router,
        private location: Location,
        private cdRef: ChangeDetectorRef,
        private _pbService: ProgressBarService,
        private _commonServiceCommon: UpsCommonService,
        private _commonService: UpsCommonService,
        private _sessionService: UpplmSessionService,
        private _apiService: UpplmApiService,
        public dashboardSearchService: QVDashboardSearchService,
        private _configurationService: ConfigurationService,
        private _translateData: TranslateDataPipe) {
        this.qvSummryRequest = new qvSummariesRequest();
        this.responseModelClone = new qvSummariesResponse();
        this.responseModel = new qvSummariesResponse();
    }

    ngOnInit() {
        this.createNewPickup = this._translateData.transform('upplm.summarydashboard.createnewpickup');
        this.createNewPickup = this.createNewPickup.replace('%[x]%', UPS_PICKUP_POINT);
        this.globalRegionCountry = this._commonService.getRegionCountry(this._commonService.locale_country);
        this.labelDays = this._translateData.transform('upplm.summarydashboard.alldays');
        this.nickNameLabel = this._translateData.transform('upplm.summarydashboard.all');
        this.totalPlacardsLegend = this._translateData.transform('upplm.common.totalplacards');
        this.backBrowser();
        //Hide breadcrumb
        let breadcrumb: any = document.querySelectorAll('.ups-breadcrumb');
        if (breadcrumb && breadcrumb.length > 0) {
            breadcrumb[0].style.display = "none";
        }

        this.searchFlag = false;
        this.dashboardSearchService.searchFlag = false;
        this.sessionData = this._sessionService.sessionData;
        this.showComponent = true;
        this.showHeaderSearchMessage = true;
        var dt = new Date();
        this.dashboardSearchService.qvSearchRequest.startDate = this.qvSummryRequest.startDate;
        this.dashboardSearchService.qvSearchRequest.endDate = this.qvSummryRequest.endDate;
        this.dashboardSearchService.cardStatus = TILE_STATUS.DEFAULT;
        this.dashboardSearchService.qvSearchRequest.locale = this._commonService.locale;
        this.valueStatic.id = 1;
        this.getCookies(COOKIES_TO_GET.SESSION_UPS_COM);
    }

    ngAfterViewChecked() {
        this.displayResize();
        this.cdRef.detectChanges();
    }

    getCookies(cookieLooking) {
        var qvCookie = new QVCookie();
        qvCookie.name = cookieLooking;
        let url = this._commonService.createURL(ServiceURLConstants.GET_QVSUMMARIES_COOKIES, ApiErrorCode.GET_QVSUMMARIES_COOKIES);
        this._apiService.PostServiceAPI(url,
            qvCookie).
            subscribe((response: any) => {
                if (response == null || response == '' || response == undefined) {
                    if (this._configurationService.appSettings.environment === ENVIRONMENTS.Development || this._configurationService.appSettings.environment === ENVIRONMENTS.CDE) {
                        this.qvSummryRequest.username = this._configurationService.appSettings.userName;
                    }
                    else {
                        this.router.navigateByUrl(RouteURLConstants.UPPLM_VIEW_DASHBOARD_ROUTE);
                        return false;
                    }
                } else {
                    this.qvSummryRequest.username = '';
                    this.qvSummryRequest.cookie = 'session_ups_com=' + response;
                    this._configurationService.appSettings.cookie = this.qvSummryRequest.cookie;
                }

                this.updateDataAndTimestamp();
                this.valueStatic.name = '30 days';
                this.valueStatic.value = 30;
                this.displaySummary = true;
            });
    }

    public resizeWindow(event: WindowResize) {
        this.bar = false;
        this.windowResize = new WindowResize();
        this.windowResize = event;
        this.sizeValue = this.windowResize.sizeBootStrap;
        this.displayResize();
    }

    updateSearchInputValidation() {
        if (this.InputKeyword.length > 1) {
            this.clickedSearchKeywordInput = true;
        }
        this.firstInputValidator = true;
    }

    displayResize() {
        if (this.windowResize.sizeBootStrap === 'xs' || this.windowResize.sizeBootStrap === 'sm') {
            this.bar = true;
            this.middleSize = false;
        } else if (this.windowResize.sizeBootStrap === 'md') {
            this.middleSize = true;
            this.bar = false;

        } else {
            this.bar = false;
            this.middleSize = false;
        }
    }

    gotoLocation() {
        setTimeout(() => {
            let breadcrumb: any = document.querySelectorAll('.ups-breadcrumb');
            if (breadcrumb && breadcrumb.length > 0) {
                breadcrumb[0].style.display = "block";
            }
            this._pbService.pb.showStatusBar = true;
            this._commonServiceCommon.url = '/locationdetails';
            this.router.navigateByUrl(RouteURLConstants.UPPLM_VIEW_LOCATIONS_DETAILS_ROUTE);
        }, 1000);
    }

    //------------------------------------------------------------
    //------------------ Actions filter ---------------------
    //------------------------------------------------------------

    public actionFilterMenu(element: HTMLButtonElement) {
        this.searchCkick = false;
        if (this.checkBoxSelected.length === 0 || this.checkBoxSelected.filter(x => x.selected === false).length === 0) {
            this.allSelected = true;
            this.applyDisabled = false;
            this.responseModel.summary.totalClientKeys.forEach(item => item.selected = true);
        } else {
            this.responseModel.summary.totalClientKeys = this.checkBoxSelected;
            let valueTrueTotalSelected: number = this.responseModel.summary.totalClientKeys.filter(x => x.selected === true).length;
            if (valueTrueTotalSelected === 0) {
                this.allSelected = true;
                this.applyDisabled = true;
            } else {
                this.allSelected = false;
                this.applyDisabled = false;
            }
        }
        this.actionFilter.show(element);
    }

    public onChecked(objUserclientkey: Clientkey) {
        let valueFalseTotalSelected: number = this.responseModel.summary.totalClientKeys.filter(x => x.selected === false).length;
        let valueTrueTotalSelected: number = this.responseModel.summary.totalClientKeys.filter(x => x.selected === true).length;
        if (valueFalseTotalSelected === 0) {
            this.applyDisabled = false;
        } else {
            if (valueTrueTotalSelected === 0) {
                this.applyDisabled = true;
            } else {
                this.applyDisabled = false;
            }
        }
        if (!objUserclientkey.selected) {
            this.allSelected = false;

        } else {
            if (valueFalseTotalSelected === 0) {
                this.allSelected = true;
            } else {
                this.allSelected = false;
            }
        }
    }

    public allClientKeys(event) {
        this.checkBoxSelected = [...this.checkBoxSelected].map(item => ({ ...item }));
        this.checked = event.target.checked;
        this.responseModel.summary.totalClientKeys.forEach(item => {
            item.selected = this.checked;
        });
        let valueTrueTotalSelected: number = this.responseModel.summary.totalClientKeys.filter(x => x.selected === true).length;
        if (valueTrueTotalSelected > 0) {
            this.applyDisabled = false;

        } else {
            this.applyDisabled = true;
        }
    }

    public closeFilter() {
        this.actionFilter.hide();
    }

    public apply() {
        this.checkBoxSelected = this.responseModel.summary.totalClientKeys;
        if (!this.showComponent) {
            this.getClientKeyByFilterQvList();
        }
        var dt = new Date();
        if (this.daysFilterSelectedDropdown == 'default') {
            this.qvSummryRequest.startDate = new Date(dt.getTime() - 1000 * 60 * 60 * 24 * 30).toString();
            this.dashboardSearchService.qvSearchRequest.startDate = new Date(dt.getTime() - 1000 * 60 * 60 * 24 * 30).toString();
            this.labelDays = this._translateData.transform('upplm.summarydashboard.last30days');
        } else if (this.daysFilterSelectedDropdown == '45days') {
            this.qvSummryRequest.startDate = new Date(dt.getTime() - 1000 * 60 * 60 * 24 * 45).toString();
            this.dashboardSearchService.qvSearchRequest.startDate = new Date(dt.getTime() - 1000 * 60 * 60 * 24 * 45).toString();
            this.labelDays = this._translateData.transform('upplm.summarydashboard.last45days');
        } else if (this.daysFilterSelectedDropdown == '60days') {
            this.qvSummryRequest.startDate = new Date(dt.getTime() - 1000 * 60 * 60 * 24 * 60).toString();
            this.dashboardSearchService.qvSearchRequest.startDate = new Date(dt.getTime() - 1000 * 60 * 60 * 24 * 60).toString();
            this.labelDays = this._translateData.transform('upplm.summarydashboard.last60days');
        } else if (this.daysFilterSelectedDropdown == 'allDays') {
            this.labelDays = this._translateData.transform('upplm.summarydashboard.alldays');
            this.qvSummryRequest.startDate = '';
            this.dashboardSearchService.qvSearchRequest.startDate = '';
        }
        this.retartValuesInSearch();
        this.qvSummryRequest.startDate = this.formatDate(new Date(this.qvSummryRequest.startDate));
        this.qvSummryRequest.endDate = this.formatDate(new Date(Date.now()));
        this.dashboardSearchService.qvSearchRequest.startDate = this.qvSummryRequest.startDate;
        this.dashboardSearchService.qvSearchRequest.endDate = this.qvSummryRequest.endDate;

        this.dashboardSearchService.searchFlag = false;
        this.searchFlag = false;
        this.updateDataAndTimestamp();
        this.actionFilter.hide();
        this.tempKeyword = '';
        this.selectedDropdDownSearch = 'Select One';
        this.tempCategory = 'Select One';
    }

    selectDropdDownSearchCategory(optionSelectedSearch) {
        this.firstInputValidator = true;
        this.InputKeywordMaxValue = this.InputKeyword.replace(/ /g, "").length > 2 ? true : false;
        this.errorCategoryDropDownSelected = optionSelectedSearch == "Select One" ? true : false;
        if (optionSelectedSearch == "Status") {
            this.showstatusDropDown = true;
        } else {
            this.showstatusDropDown = false;
        }
    }

    retartValuesInSearch() {
        this.firstInputValidator = false;
        this.dashboardSearchService.qvSearchRequest.query = '';
        this.dashboardSearchService.qvSearchRequest.queryBy = '';
        this.showstatusDropDown = false;
        this.searchCkick = false;
        this.InputKeyword = '';
        this.selectedDropdDownSearch = 'Select One';
        this.dashboardSearchService.searchFlag = false;
        this.InputKeywordMaxValue = false;
    }

    public formatDate(fDate) {
        let dateFormated = "";
        if (this.qvSummryRequest.startDate != "") {
            let day = fDate.getDate();
            day = day < 10 ? "0" + day : day;
            let month = fDate.getMonth() + 1;
            month = month < 10 ? "0" + month : month;
            let year = fDate.getFullYear();
            dateFormated = year + "-" + month + "-" + day;
        }

        return dateFormated;
    }

    callApiGetSummaries() {

        let url = this._commonService.createURL(ServiceURLConstants.GET_QVSUMMARIES, ApiErrorCode.GET_QVSUMMARIES);
        this._apiService.PostServiceAPI(url, this.qvSummryRequest).
            subscribe((response: qvSummariesResponse) => {
                if (response.errors) {
                    //Handle errors
                } else {
                    this.responseModel = response;
                    if (this.validationCheckBoxesSelectedAll()) {
                        this.responseModel = response;
                    }
                    this.getTotalClientKeys();
                    this.getFilterByClientKey(this.responseModel);
                    //fill cards
                    if (!this.comesFromListView) {
                        this.listTilesTotalAndGlobalTotal(this.ClientKeySelected);
                    }
                }
            });
    }

    getTotalClientKeys() {
        this.responseModel.summary.totalClientKeys = this.compareUserClientKeysLocalAndServer(this.checkBoxSelected, this.responseModel.summary.totalClientKeys);
        if (this.checkBoxSelected.filter(x => x.selected == true).length > 0) {
            this.dashboardSearchService.qvSearchRequest.clientKeys = this.checkBoxSelected.filter(x => x.selected === true).map(o => o['clientKey']);
        } else {
            this.dashboardSearchService.qvSearchRequest.clientKeys = this.responseModel.summary.totalClientKeys.map(ck => ck['clientKey']);
        }
    }

    public getFilterByClientKey(responseModel: qvSummariesResponse) {
        this.filter = this.checkBoxSelected.filter(x => x.selected == true);
        if (this.filter.length > 0) {
            this.ClientKeySelected = [];
            this.nickNameLabel = '';
            this.filter.forEach((x, index) => {
                let objectClient = responseModel.summary.assignedClientKeys.filter(item => item.clientKey === x.clientKey)[0];
                if (this.allSelected) {
                    this.nickNameLabel = this._translateData.transform('upplm.summarydashboard.all');
                }
                else {
                    if (index === 0) {
                        this.nickNameLabel += x.nickname;
                    } else {
                        this.nickNameLabel += ', ' + x.nickname;
                    }
                }
                if (objectClient != undefined) {
                    this.ClientKeySelected.push(objectClient);
                }
            })
        } else {
            this.ValidateCheckboxSelection(responseModel.summary.assignedClientKeys);
        }
    }

    ValidateCheckboxSelection(assignedClientKeys: AssignedClientKey[]): void {
        if (this.responseModel.summary.assignedClientKeys && this.validationCheckBoxesSelectedAll()) {
            this.ClientKeySelected = assignedClientKeys;
        } else {
            this.nickNameLabel = "";
            this.ClientKeySelected = [];
        }
    }

    public getClientKeyByFilterQvList() {
        this.filter = this.checkBoxSelected.filter(x => x.selected == true);
        if (this.filter.length > 0) {
            this.ClientKeySelected = [];
            this.nickNameLabel = '';
            this.filter.forEach((x, index) => {
                if (this.allSelected) {
                    this.nickNameLabel = this._translateData.transform('upplm.summarydashboard.all');
                }
                else {
                    if (index === 0) {
                        this.nickNameLabel += x.nickname;
                    } else {
                        this.nickNameLabel += ', ' + x.nickname;
                    }
                }

            })
        }
    }

    toggleView(target: string, status: string) {
        this.dashboardSearchService.cardStatus = status;
        this.isLoading = true;

        const hamMenuElement = document.getElementsByClassName('ups-toggle_view_wrapper ups-toggle_view_container_popup ups-toggle_view_container_popup_sm ups-table_toggle_view ups-form_wrap');
        if (hamMenuElement[0]) {
            hamMenuElement[0].setAttribute('hidden', 'true');
        }

        if (target === 'List') {
            this.dashboardSearchService.isListView = true;
            this.showComponent = false;
            this.showHeaderSearchMessage = false;
            this.displayList = true;
            this.displaySummary = false;
            this.cardStatusSelected = status;
            this.prepareQvListRequest(status);
        } else {
            this.dashboardSearchService.isListView = false;
            this.displaySummaryLink = false;
            this.showComponent = true;
            this.showHeaderSearchMessage = true;
            this.displayList = false;
            this.displaySummary = true;
            this.totalPlacardsLegend = this._translateData.transform('upplm.common.totalplacards');
        }
        this.updateDataAndTimestamp();
        this.isLoading = false;
    }

    public redirecToList(status: string) {
        this.dashboardSearchService.searchFlag = false;
        this.searchFlag = false;
        this.dashboardSearchService.cardStatus = status;
        this.cardStatusSelected = status;
        this.displaySummaryLink = true;
        this.toggleView("List", status);
    }

    updateDataAndTimestampClick() {
        this.tempCategory = this._translateData.transform('upplm.common.selectone');
        this.tempKeyword = '';
        this.retartValuesInSearch();
        this.showHeaderSearchMessage = true;
        this.dashboardSearchService.searchFlag = false;
        this.searchCkick = false;
        this.searchFlag = false;
        var dt = new Date();
        this.qvSummryRequest.startDate = this.dashboardSearchService.qvSearchRequest.startDate;
        this.qvSummryRequest.endDate = this.dashboardSearchService.qvSearchRequest.endDate;

        this.updateDataAndTimestamp();
    }

    updateDataAndTimestamp() {
        this.comesFromListView = false;
        this.timeToStamp = new Date(Date.now());
        this.refreshListTimestamp = true;
        if (!this.dashboardSearchService.isListView) {
            this.callApiGetSummaries();
        } else {//Emit only if is in the list view
            this.getTotalClientKeys();
            this.dashboardSearchService.subject.next(this.refreshListTimestamp);
        }
    }

    listTilesTotalAndGlobalTotal(clientKeys: Array<AssignedClientKey>) {
        let cardList: Array<cards> = [];
        let cardListCancelled: Array<cards> = [];
        let itemCardsData: cardsData;
        let totalTile: number = 0;
        this.listCardsData = [];
        this.totalPlacards = 0;
        clientKeys.forEach((item) => {
            let cardItem: cards;
            let list: any = [];
            list = item.placardIdList.filter(x => x.placardStatus.toLowerCase() === PLACARD_STATUS.CREATED.toLowerCase() || x.placardStatus.toLowerCase() === PLACARD_STATUS.EXPIRED.toLowerCase());
            if (list.length !== 0) {

                list.forEach(itemObject => {
                    cardItem = new cards();
                    cardItem.placardId = itemObject.placardId;
                    cardItem.placardStatus = itemObject.placardStatus;
                    cardItem.statusDescription = CARDS_STATUS.CONFIRM_PLACARD_DISPLAY;
                    cardItem.clientKey = item.clientKey;
                    cardList.push(cardItem);
                });
            }
            list = [];
            list = item.placardIdList.filter(x => x.placardStatus.toLowerCase() === PLACARD_STATUS.PENDING.toLowerCase() || x.placardStatus.toLowerCase() === PLACARD_STATUS.ACTIVE.toLowerCase() || x.placardStatus.toLowerCase() === PLACARD_STATUS.CREATED_2.toLowerCase() || x.placardStatus.toLowerCase() === PLACARD_STATUS.EXPIRED_2.toLowerCase() || x.placardStatus.toLowerCase() === PLACARD_STATUS.REJECTED.toLowerCase() || x.placardStatus.toLowerCase() === PLACARD_STATUS.AGED.toLowerCase());
            if (list.length !== 0) {

                list.forEach(itemObject => {
                    cardItem = new cards();
                    cardItem.placardId = itemObject.placardId;
                    cardItem.placardStatus = itemObject.placardStatus;
                    cardItem.statusDescription = CARDS_STATUS.DISPLAYED;
                    cardItem.clientKey = item.clientKey;
                    cardList.push(cardItem);
                });
            }
            list = [];
            list = item.placardIdList.filter(x => x.placardStatus.toLowerCase() === PLACARD_STATUS.DISPATCHED.toLowerCase() || x.placardStatus.toLowerCase() === PLACARD_STATUS.PAUSED.toLowerCase());
            if (list.length !== 0) {
                list.forEach(itemObject => {
                    cardItem = new cards();
                    cardItem.placardId = itemObject.placardId;
                    cardItem.placardStatus = itemObject.placardStatus;
                    cardItem.statusDescription = CARDS_STATUS.READY_FOR_PICKUPS;
                    cardItem.clientKey = item.clientKey;
                    cardList.push(cardItem);
                });
            }
            list = [];
            list = item.placardIdList.filter(x => x.placardStatus.toLowerCase() === PLACARD_STATUS.CANCELLED.toLowerCase());
            if (list.length !== 0) {
                list.forEach(itemObject => {
                    cardItem = new cards();
                    cardItem.placardId = itemObject.placardId;
                    cardItem.placardStatus = itemObject.placardStatus;
                    cardItem.statusDescription = itemObject.statusDescription;
                    cardListCancelled.push(cardItem);
                });
            }
        });

        //total placards
        this.totalPlacards = [...new Set(cardList.map(x => x.placardId))].length;
        //total cancelled placards
        this.totalCancelledPlacards = [...new Set(cardListCancelled.filter(x => x.placardStatus === PLACARD_STATUS.CANCELLED).map(x => x.placardId))].length;
        //fill cards
        this.statusColor.forEach(element => {
            itemCardsData = new cardsData();
            totalTile = [...new Set(cardList.filter(x => x.statusDescription === element).map(x => x.placardId))].length;
            if (totalTile !== 0) {
                switch (element) {
                    case CARDS_STATUS.CONFIRM_PLACARD_DISPLAY:
                        itemCardsData.color = 'ups-alert';
                        itemCardsData.description = this._translateData.transform('upplm.common.confirmplacarddisplay');
                        itemCardsData.total = totalTile.toString();
                        itemCardsData.statusDescription = CARDS_STATUS.CONFIRM_PLACARD_DISPLAY;
                        break;
                    case CARDS_STATUS.DISPLAYED:
                        itemCardsData.color = 'ups-success';
                        itemCardsData.description = this._translateData.transform('upplm.summarydashboard.status.displayed');
                        itemCardsData.total = totalTile.toString();
                        itemCardsData.statusDescription = CARDS_STATUS.DISPLAYED;
                        break;
                    case CARDS_STATUS.READY_FOR_PICKUPS:
                        itemCardsData.color = 'ups-success';
                        itemCardsData.description = this._translateData.transform('upplm.summarydashboard.status.readyforpickups');
                        itemCardsData.total = totalTile.toString();
                        itemCardsData.statusDescription = CARDS_STATUS.READY_FOR_PICKUPS;
                        break;
                    default:
                        itemCardsData = new cardsData();
                        break;
                }
                this.listCardsData.push(itemCardsData);
                this.totalCardsFlex = this.listCardsData.length;
            }
        });
        this.isLoading = false;
    }

    prepareQvListRequest(status: string) {
        if (this._configurationService.appSettings.environment === ENVIRONMENTS.Development || this._configurationService.appSettings.environment === ENVIRONMENTS.CDE) {
            this.qvListRequest.username = this._configurationService.appSettings.userName;
        }
        else {
            this.qvListRequest.cookie = this._configurationService.appSettings.cookie;
        }

        this.qvListRequest.startDate = this.dashboardSearchService.qvSearchRequest.startDate;
        this.qvListRequest.endDate = this.dashboardSearchService.qvSearchRequest.endDate;
        this.qvListRequest.locale = this._commonService.locale;
        let statusFilter = STATUS_BY_TILE.filter(stat => stat.status === status);
        if (!this.dashboardSearchService.searchFlag) {

            this.qvListRequest.placardStatus = statusFilter['0'].placards_status;
            if (this.checkBoxSelected.filter(x => x.selected == true).length > 0) {
                this.qvListRequest.clientKeys = this.checkBoxSelected.filter(x => x.selected === true).map(o => o['clientKey']);
            } else {
                this.qvListRequest.clientKeys = this.responseModel.summary.totalClientKeys.map(ck => ck['clientKey']);
            }
            this.qvListRequest.query = '';
            this.qvListRequest.queryBy = '';
            this.qvListRequest.offset = '';
            this.qvListRequest.limit = '';
            this.qvListRequest.sort = '';

        } else {
            // it allways enter when the search component is  click on button
            this.qvListRequest.query = this.dashboardSearchService.qvSearchRequest.query;
            this.qvListRequest.queryBy = this.dashboardSearchService.qvSearchRequest.queryBy;
            this.qvListRequest.placardStatus = statusFilter['0'].placards_status;
            this.qvListRequest.sort = this.dashboardSearchService.qvSearchRequest.sort;
            this.searchCkick = false;
        }
        this.dashboardSearchService.qvSearchRequest = this.qvListRequest;
    }

    updateTotalPlacardsFromList(message: string[]) {
        this.comesFromListView = true;
        this.totalPlacards = Number(message[0]);
        this.totalPlacardsLegend = message[1];
    }

    validationCheckBoxesSelectedAll(): boolean {
        let result: boolean = false;
        let anyPlacardSelected: number = this.responseModel.summary.totalClientKeys ? this.responseModel.summary.totalClientKeys.filter(x => x.selected === true || x.selected === undefined).length : - 1;
        if (this.checkBoxSelected.length === 0 || anyPlacardSelected > 0) {
            result = true;
        }
        return result;
    }

    compareUserClientKeysLocalAndServer(clientKeysLocal: Array<Clientkey>, clientKeysServer: Array<Clientkey>): Array<Clientkey> {
        if (clientKeysLocal.length !== 0) {
            clientKeysServer.forEach((x1) => clientKeysLocal.forEach((x2) => {
                if (x1.clientKey === x2.clientKey) {
                    x1.selected = x2.selected;
                }
            }));
        }
        return clientKeysServer;
    }

    getPlacardDetailFromListView(placardId: string) {
        this.showPlacardDetail = true;
        this.placardId = placardId;
    }

    hidePlacardDetail(showPlacardDetail: boolean) {
        this.showPlacardDetail = showPlacardDetail;
    }

    public hideClasesInput() {
        this.showClasesInput = false;
    }

    public searchClicked() {
        this.cleanErrors();
        this.searchCkick = this.searchCkick ? false : true;

        if (!this.searchCkick) {
            this.restoreValuesSearchComponent();
        } else {
            if (this.selectedDropdDownSearch == 'Select One') {
                this.InputKeywordMaxValue = this.InputKeyword.replace(/ /g, "").length > 2 ? true : false;
                this.showClasesInput = true;

            }
        }
        this.firstInputValidator = false;
    }

    saveValuesSearchComponent() {
        this.tempCategory = this.selectedDropdDownSearch;

        if (this.selectedDropdDownSearch != 'Status') {
            this.tempSelectionStatus = false;
            this.tempKeyword = this.InputKeyword;
            this.statusDropdDownSearch = 'Ready';

        } else {
            this.tempKeyword = this.statusDropdDownSearch;
            this.InputKeyword = '';
            this.tempSelectionStatus = true;
        }
    }

    restoreValuesSearchComponent() {
        this.selectedDropdDownSearch = this.tempCategory;

        if (this.tempSelectionStatus && this.selectedDropdDownSearch != 'Select One') {
            this.statusDropdDownSearch = this.tempKeyword;
            this.showstatusDropDown = true;
        } else if (!this.tempSelectionStatus) {
            this.InputKeyword = this.tempKeyword;
            this.showstatusDropDown = false;
        }
    }

    searchSend() {
        this.cleanErrors();
        var isValidSearch = false;
        isValidSearch = this.validationsSearch();
        if (isValidSearch) {
            this.saveValuesSearchComponent();
            this.dashboardSearchService.searchFlag = true;
            this.toggleView('List', this.dashboardSearchService.cardStatus);
        }
        this.InputKeywordMaxValue = this.InputKeyword.replace(/ /g, "").length > 2 ? true : false;
    }

    private validationsSearch(): boolean {
        this.messageSearch = '';
        if (this.selectedDropdDownSearch !== SEARCH_VALUE_KEY.STATUS && this.selectedDropdDownSearch !== SEARCH_VALUE_KEY.DEFAULT) {
            return this.InputKeyword.length > 0 ? this.validationForSearchcriteria() : this.validationForNoValueInputAndIsNoStatusSearch();
        }
        if (this.selectedDropdDownSearch === SEARCH_VALUE_KEY.DEFAULT) {
            return this.validationForNoSelectedValueSearch();
        }
        if (this.selectedDropdDownSearch === SEARCH_VALUE_KEY.STATUS) {
            return this.validationForStatusSearch();
        }
        return false;
    }

    validationForNoSelectedValueSearch(): boolean {
        this.errorCategoryDropDownSelected = true;
        this.errorCategoryHeader = true;
        return false;
    }

    validationForNoValueInputAndIsNoStatusSearch(): boolean {
        this.errorKeywordHeader = true;
        return false;
    }

    validationForStatusSearch(): boolean {
        this.getStatusFromDropdown();
        this.showOptionSearchCategory = this.selectedDropdDownSearch;
        this.optionSearchCategoryToShow = this._translateData.transform('upplm.common.status');
        this.showOptionSearchKeyword = this.statusDropdDownSearch;
        this.dashboardSearchService.qvSearchRequest.queryBy = 'placardStatus';
        return true;
    }

    validationForSearchcriteria(): boolean {
        this.optionSearchKeywordToShow = this.InputKeyword;
        const searchCriteria = SEARCH_CRITERIA.find(value => value.SEARCH_VALUE_KEY === this.selectedDropdDownSearch).SEARCH_QUERY_BY;
        this.dashboardSearchService.qvSearchRequest.query = this.InputKeyword;
        this.dashboardSearchService.qvSearchRequest.queryBy = searchCriteria;
        this.messageSearch = this.getMessageToShowInSearch(searchCriteria, this.InputKeyword);
        return true;
    }

    getMessageToShowInSearch(searchCriteria: string, keyWord: string) {
        let message = this.messageSearch = this._translateData.transform('upplm.summarydashboard.searchMessageResult');
        message = message.replace(TRANSLATE_CRITERIA_PARAMETER.PARAMETER_1, keyWord);
        return message.replace(TRANSLATE_CRITERIA_PARAMETER.PARAMETER_2, this._translateData.transform(SEARCH_CRITERIA.find(x => x.SEARCH_QUERY_BY === searchCriteria).TEXT_SEARCH_CRITERIA));
    }

    getStatusFromDropdown() {
        switch (this.statusDropdDownSearch) {
            case 'Ready':
                this.dashboardSearchService.qvSearchRequest.query = `${PLACARD_STATUS.DISPATCHED}`;
                this.optionSearchKeywordToShow = this._translateData.transform('upplm.common.ready');
                break;
            case 'Awaiting UPS Approval':
                this.dashboardSearchService.qvSearchRequest.query = `${PLACARD_STATUS.CREATED_2}, ${PLACARD_STATUS.PENDING}, ${PLACARD_STATUS.ACTIVE}`;
                this.optionSearchKeywordToShow = this._translateData.transform('upplm.common.awaitingapproval');
                break;
            case 'Created':
                this.dashboardSearchService.qvSearchRequest.query = `${PLACARD_STATUS.CREATED_1}`;
                this.optionSearchKeywordToShow = this._translateData.transform('upplm.common.created');
                break;
            case 'First Pickup Date Delayed':
                this.dashboardSearchService.qvSearchRequest.query = `${PLACARD_STATUS.REJECTED}, ${PLACARD_STATUS.AGED}, ${PLACARD_STATUS.EXPIRED_2}`;
                this.optionSearchKeywordToShow = this._translateData.transform('upplm.common.firstpickupdatedelayed');
                break;
            case 'Expired':
                this.dashboardSearchService.qvSearchRequest.query = `${PLACARD_STATUS.EXPIRED_1}`;
                this.optionSearchKeywordToShow = this._translateData.transform('upplm.common.expired');
                break;
            case 'Pickups Paused':
                this.dashboardSearchService.qvSearchRequest.query = `${PLACARD_STATUS.PAUSED}`;
                this.optionSearchKeywordToShow = this._translateData.transform('upplm.common.pickupspaused');
                break;
        }
    }

    cleanErrors() {
        this.errorKeywordHeader = false;
        this.errorCategoryDropDownSelected = false;
        this.errorCategoryHeader = false;
        this.InputKeywordMaxValue = false;
    }

    keyuppress() {
        this.InputKeywordMaxValue = this.InputKeyword.replace(/ /g, "").length > 2 ? true : false;
        this.firstInputValidator = true;
    }

    focusInputKeyword() {
        document.getElementById("cvSearchKeywordPhrase").focus();
    }

    private backBrowser() {
        this.subscription = <Subscription>this.location.subscribe(val => {
            this._pbService.pb.showStatusBar = true;
            this._commonServiceCommon.url = '/locationdetails';
            this.router.navigateByUrl(RouteURLConstants.UPPLM_VIEW_LOCATIONS_DETAILS_ROUTE);
        });
    }
}